var _defs, _path, _path2, _path3, _rect, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _use, _use2, _use3, _use4, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKenya = function SvgKenya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 740"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kenya_svg__a",
    d: "m935.37 493.73.17.1 4.54-7.86c.27-.07.41-.32.56-.58.1-.17.49-.84.65-1.72-.67.58-1.06 1.26-1.16 1.43-.15.25-.29.51-.22.77z",
    className: "kenya_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kenya_svg__b",
    d: "m940.93 493.73-.17.1-4.54-7.86c-.27-.07-.41-.32-.56-.58-.1-.17-.49-.84-.65-1.72.67.58 1.06 1.26 1.16 1.43.15.25.29.51.22.77z",
    className: "kenya_svg__cls-10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1500v740H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "m909.08 485.67-32.56-25.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.8,
    d: "M876.42 461.71c.87 0 1.57-.7 1.57-1.57s-.7-1.57-1.57-1.57-1.57.7-1.57 1.57.7 1.57 1.57 1.57Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109.6,
    height: 26,
    x: 908.62,
    y: 476.1,
    fill: "currentColor",
    rx: 13,
    ry: 13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M954.72 493.86v-9.19h1.97v9.19zm1.49-2.72-.42-1.79 4.65-4.69h2.39l-6.62 6.47Zm4.47 2.72-3.44-4.57 1.35-1.17 4.42 5.74h-2.34Zm6.03.13c-.75 0-1.41-.15-1.97-.46s-1-.73-1.31-1.26c-.32-.53-.47-1.15-.47-1.84 0-.53.09-1.02.26-1.47s.42-.83.74-1.16c.31-.33.69-.58 1.12-.76q.645-.27 1.41-.27c.47 0 .91.09 1.31.26s.75.41 1.04.72.52.68.68 1.1q.24.63.21 1.38v.58h-5.59l-.3-1.14h4.35l-.21.24v-.29c-.02-.24-.09-.45-.23-.64s-.31-.34-.52-.45-.45-.16-.71-.16c-.38 0-.71.07-.98.22s-.47.37-.61.66q-.21.435-.21 1.05c0 .615.09.78.27 1.09s.43.54.76.72c.33.17.72.26 1.16.26.31 0 .59-.05.84-.14.25-.1.53-.26.81-.5l.89 1.25q-.375.345-.84.57c-.31.15-.62.27-.95.35q-.48.12-.96.12Zm4.27-.13v-6.95h1.79l.05 1.42-.37.16c.1-.32.27-.6.52-.86s.55-.47.9-.62c.35-.16.72-.24 1.1-.24.52 0 .96.1 1.32.32.35.21.62.53.8.95s.27.95.27 1.57v4.25h-1.86v-4.11c0-.31-.04-.58-.13-.79a.93.93 0 0 0-.4-.47q-.27-.15-.66-.12c-.21 0-.41.03-.58.1-.18.07-.33.16-.46.28q-.195.18-.3.42c-.07.16-.11.33-.11.51v4.18H971Zm8.94 3.01 1.52-3.57.03 1.08-3.39-7.47h2.11l1.69 4c.07.15.14.32.2.52.07.2.12.39.16.57l-.31.13q.075-.225.18-.51c.105-.285.14-.4.21-.62l1.46-4.1h2.13l-2.91 6.95-1.2 3.02h-1.89Zm9.33-2.88c-.58 0-1.1-.16-1.56-.47s-.83-.74-1.1-1.29-.41-1.16-.41-1.86.14-1.32.41-1.86.65-.96 1.12-1.27 1.01-.47 1.61-.47c.34 0 .65.05.94.15s.53.24.75.41c.21.18.4.38.54.6.15.23.25.47.31.74l-.39-.07v-1.69h1.85v6.95h-1.88v-1.67l.42-.04c-.07.25-.18.48-.34.7s-.35.41-.58.58a2.8 2.8 0 0 1-1.7.56Zm.52-1.62c.35 0 .66-.08.92-.25s.47-.4.61-.7.22-.65.22-1.06-.07-.74-.22-1.04a1.65 1.65 0 0 0-1.53-.96c-.35 0-.64.08-.9.26-.26.17-.46.4-.61.7s-.22.64-.22 1.04.07.75.22 1.06c.15.3.35.54.61.7.26.17.56.25.9.25",
    className: "kenya_svg__cls-7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 938.28,
    cy: 489.1,
    r: 10,
    fill: "#fff",
    className: "kenya_svg__cls-7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M938.21 479.95c2.53 0 4.81 1.02 6.47 2.68s2.68 3.94 2.68 6.47-1.02 4.81-2.68 6.47-3.94 2.68-6.47 2.68-4.81-1.02-6.47-2.68-2.68-3.94-2.68-6.47 1.02-4.81 2.68-6.47a9.1 9.1 0 0 1 6.47-2.68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M938.21 480.65a8.435 8.435 0 0 1 8.44 8.44 8.435 8.435 0 0 1-8.44 8.44 8.435 8.435 0 0 1-8.44-8.44 8.435 8.435 0 0 1 8.44-8.44",
    className: "kenya_svg__cls-7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M938.21 481.36c4.27 0 7.73 3.46 7.73 7.73s-3.46 7.73-7.73 7.73-7.73-3.46-7.73-7.73 3.46-7.73 7.73-7.73",
    className: "kenya_svg__cls-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M945.31 486.01h-14.18c1.19-2.73 3.92-4.65 7.09-4.65s5.9 1.91 7.09 4.65",
    className: "kenya_svg__cls-5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M931.14 492.23h14.15c-1.2 2.71-3.92 4.6-7.07 4.6s-5.87-1.89-7.07-4.6Z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__a",
    className: "kenya_svg__cls-10"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__a",
    className: "kenya_svg__cls-7"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__b",
    className: "kenya_svg__cls-10"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__b",
    className: "kenya_svg__cls-7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M930.84 491.45h5.46c.29.78 1.26 2.33 1.85 2.33s1.56-1.56 1.85-2.33h5.58c.24-.74.37-1.53.37-2.35s-.12-1.58-.35-2.31H940c-.29-.78-1.26-2.33-1.85-2.33s-1.56 1.56-1.85 2.33h-5.48a7.7 7.7 0 0 0 .02 4.66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M940 491.45c.29-.78.49-1.56.49-2.33s-.19-1.56-.49-2.33c-.29.78-.49 1.56-.49 2.33s.19 1.56.49 2.33m-3.69 0c-.29-.78-.49-1.56-.49-2.33s.19-1.56.49-2.33c.29.78.49 1.56.49 2.33s-.19 1.56-.49 2.33",
    className: "kenya_svg__cls-5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M938.54 489.12c0-.32-.17-.58-.39-.58s-.39.26-.39.58.17.58.39.58.39-.26.39-.58",
    className: "kenya_svg__cls-7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M938.25 489.69s.39.78.39 2.04-.39 2.04-.39 2.04zm-.19-1.14s-.39-.78-.39-2.04.39-2.04.39-2.04zm0 1.14s-.39.78-.39 2.04.39 2.04.39 2.04zm.19-1.14s.39-.78.39-2.04-.39-2.04-.39-2.04z",
    className: "kenya_svg__cls-7"
  })));
};
export default SvgKenya;